import { render, staticRenderFns } from "./modalReview.vue?vue&type=template&id=f80a949e"
import script from "./modalReview.vue?vue&type=script&lang=js"
export * from "./modalReview.vue?vue&type=script&lang=js"
import style0 from "./modalReview.vue?vue&type=style&index=0&id=f80a949e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports